import { skipToken, useMutation, useQuery } from '@tanstack/react-query'
import { agentsApi } from '../../api/agents-api'
import { agentKeys } from '../../api/query-keys'

export function useAgentUpgradeTargets(
  entityId: string,
  agentId: string,
  enabled: boolean,
) {
  return useQuery({
    queryKey: agentKeys.upgradeTargets(entityId, agentId),
    queryFn: () => agentsApi.getAgentUpgradeTargets(entityId, agentId),
    enabled,
  })
}

export function useUpgradeAgent(entityId: string, agentId: string) {
  return useMutation({
    mutationFn: (releaseId: string) =>
      agentsApi.upgradeAgent(entityId, agentId, releaseId),
    meta: { invalidates: [agentKeys.root] },
  })
}

export function useDisconnectAgent(entityId: string, agentId: string) {
  return useMutation({
    mutationFn: (minutes: number) =>
      agentsApi.disconnectAgent(entityId, agentId, minutes),
    meta: { invalidates: [agentKeys.root] },
  })
}

export function useAgentConnectionHistory(entityId: string | null, agentId: string | null) {
  return useQuery({
    queryKey: agentKeys.connectionHistory(entityId ?? '', agentId ?? ''),
    queryFn: entityId === null || agentId === null
      ? skipToken
      : () => agentsApi.getAgentConnectionHistory(entityId, agentId),
    refetchInterval: 60_000,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: 'always',
  })
}
